import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";

const DatesheetPT2 = () => {
  useEffect(() => {
    document.title = "Datesheet - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li><Link to="/">Home</Link></li>
          <li>Academics</li>
          <li>Datesheet</li>
          <li>PT - 2</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Datesheet PT-2</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-6">
              <a
                href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/assessment_lkg_2.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="sample-blk">
                  <div>
                   
                    <p>PT 2</p>
                    <span>click here</span>
                  </div>
                  <LazyLoad>
                    <img
                      alt="PDF"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DatesheetPT2;
